export const HEADER_CONST = {
  INSIGHTS_TEXT : "Insights",
  KNOWLEDGE_CENTER : "Knowledge Center",
}